import * as Styled from '../common/CommonStyledComponents';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class OrderDisabledShippedItems extends Component {
  static propTypes = {
    id: PropTypes.string,
    trackingNumber: PropTypes.string,
    name: PropTypes.string,
  };

  render() {
    const { id, trackingNumber, name } = this.props;
    const trackingDetails = (
      <Styled.ItemRow key={id + '-tracking'}>
        <Styled.TrackingContent key="content">
          <Styled.ItemDetail key="itemDetail" active={false}>
            {`Tracking numbers: ${trackingNumber}`}
          </Styled.ItemDetail>
        </Styled.TrackingContent>
      </Styled.ItemRow>
    );

    return (
      <div>
        <Styled.ItemRow key={id}>
          <Styled.RowContent key="content">
            <Styled.ItemDetail key="itemDetail" active={false}>
              {name}
            </Styled.ItemDetail>
          </Styled.RowContent>
        </Styled.ItemRow>
        {!!trackingNumber && trackingDetails}
      </div>
    );
  }
}

export default OrderDisabledShippedItems;
